import { updateArticleCurationState } from 'modules/EmailBrowser/utils';
import { MY_ACCOUNTS, ACCOUNTS_NEWS, ACCOUNT_SEARCH } from '../../../constants/actionTypes';
import * as interfaces from '../interfaces';
import { IFiltersItem, INewArticlesItem, INewsArticlesAction } from '../MyAccounts/';

const myAccountsInitialState = {
  data: Array<interfaces.IAccountItem>(),
  loading: false,
  selectedAccounts: Array<interfaces.ISelectedAccounts>(),
  selectedFilters: Array<number>(),
  previouslySelectedFilters: Array<number>(),
  selectAll: false,
  onboard: false,
  count: 0,
};

const accountSearchInitialState = {
  data: Array<interfaces.IAccountSearchItem>(),
  loading: false,
  searchedAccountsCount: 0,
};

const accountsNewsInitialState = {
  articles: Array<INewArticlesItem>(),
  filters: Array<IFiltersItem>(),
  loading: false,
  selectAll: false,
  page: 0,
};

export const myAccountsReducer = (state = myAccountsInitialState, action: interfaces.IMyAccountsAction) => {
  const new_state = { ...state };
  switch (action.type) {
    case MY_ACCOUNTS.LOAD_SUCCESS:
      new_state.loading = false;
      new_state.data = [...state.data, ...action.payload];
      new_state.count = [...state.data, ...action.payload].length;
      if (new_state.data.length == 0) {
        new_state.onboard = true;
      } else {
        new_state.onboard = false;
      }
      return new_state;

    case MY_ACCOUNTS.RESET_ACOUNT:
      new_state.loading = false;
      new_state.data = [];
      return new_state;

    case MY_ACCOUNTS.LOAD:
      new_state.loading = true;
      return new_state;
    case MY_ACCOUNTS.LOAD_FAIL:
      new_state.loading = false;
      return new_state;
    case MY_ACCOUNTS.RESET_SELECTED_ACCOUNTS:
      new_state.selectedAccounts = [];
      new_state.data = new_state.data.map((x, index) => {
        x.state = '';
        return x;
      });
      return new_state;
    case MY_ACCOUNTS.UPDATE_STATE:
      new_state.data = [...action.payload];
      new_state.selectedAccounts = [...action.selectedAccounts];
      return new_state;

    case MY_ACCOUNTS.UPDATE_FILTERS_STATE:
      new_state.selectedFilters = [...action.selectedFilters];
      return new_state;

    case MY_ACCOUNTS.UPDATE_PREVIOUS_FILTERS_STATE:
      new_state.previouslySelectedFilters = new_state.selectedFilters;
      return new_state;

    case MY_ACCOUNTS.SET_SELECT_ALL:
      new_state.selectAll = action.selectAll;
      return new_state;

    case MY_ACCOUNTS.ADD_NEW_ACCOUNT:
      new_state.data = [action.new_account, ...state.data];
      //* updating the on boarding state. when an account is added.
      new_state.onboard = false;
      return new_state;
    case MY_ACCOUNTS.REMOVE_ACCOUNT:
      new_state.data = state.data.filter((item) => item.accountId !== action.accountId);
      new_state.count = new_state.count - 1;
      return new_state;
    case MY_ACCOUNTS.REMOVE_SELECTED_ACCOUNT:
      new_state.selectedAccounts = state.selectedAccounts.filter((item) => item.accountId !== action.accountId);
      new_state.count = new_state.count - 1;
      return new_state;
    case MY_ACCOUNTS.UPDATE_LENGTH:
      if (state.count === 0) {
        new_state.onboard = false;
      }
      new_state.count = state.count + 1;
      return new_state;

    default:
      return state;
  }
};

export const accountSearchReducer = (state = accountSearchInitialState, action: interfaces.IAccountSearchAction) => {
  const new_state = { ...state };
  switch (action.type) {
    case ACCOUNT_SEARCH.LOAD_SUCCESS:
      new_state.loading = false;
      if (action.payload) {
        new_state.data = [...state.data, ...action.payload];
      }
      if (action.accountsCount) {
        new_state.searchedAccountsCount = action.accountsCount;
      }
      return new_state;
    case ACCOUNT_SEARCH.REMOVE_ACCOUNT:
      new_state.data = new_state.data.map((account) => {
        return {
          ...account,
          flag: account.companyid === action.companyId ? 'False' : account.flag,
          state: account.companyid === action.companyId ? '' : account.state,
          loading: false,
        };
      });
      return new_state;
    case ACCOUNT_SEARCH.LOAD:
      new_state.loading = true;
      new_state.data = [];
      return new_state;
    case ACCOUNT_SEARCH.LOAD_FAIL:
      new_state.loading = false;
      return new_state;
    case ACCOUNT_SEARCH.UPDATE_STATE:
      if (action.payload) new_state.data = [...action.payload];
      return new_state;
    case ACCOUNT_SEARCH.RESET_SELECTION:
      new_state.data.forEach((account) => (account.state = ''));
      return new_state;
    case ACCOUNT_SEARCH.ADD_LOAD:
      const index = state.data.findIndex((item) => item.companyid === action.companyId);
      if (index > -1) {
        state.data[index].loading = true;
        new_state.data = [...state.data];
      }
      return new_state;
    case ACCOUNT_SEARCH.UPDATE_SELECTED_STATE:
      const accountIndex: number = state.data.findIndex((item) => item.companyid === action.companyId);
      if (accountIndex > -1 && action.updatedState !== null && action.updatedState !== undefined) {
        new_state.data[accountIndex].state = action.updatedState;
      }
      return new_state;
    case ACCOUNT_SEARCH.RESET_ACCOUNT:
      new_state.loading = false;
      new_state.data = [];
      return new_state;
    default:
      return state;
  }
};

export const accountsNewsReducer = (state = accountsNewsInitialState, action: INewsArticlesAction) => {
  const new_state = { ...state };
  switch (action.type) {
    case ACCOUNTS_NEWS.LOAD_FILTERS_SUCCESS:
      new_state.filters = action.filters;
      return new_state;

    case ACCOUNTS_NEWS.LOAD_SUCCESS:
      new_state.loading = false;
      new_state.articles = [...state.articles, ...action.articles];
      new_state.page += 1;
      return new_state;
    case ACCOUNTS_NEWS.LOAD:
      new_state.loading = true;
      return new_state;
    case ACCOUNTS_NEWS.LOAD_FAIL:
      new_state.loading = false;
      return new_state;
    case ACCOUNTS_NEWS.FILTER_MODE_ON:
      new_state.loading = true;
      new_state.articles = [];
      new_state.page = 0;
      return new_state;
    case ACCOUNTS_NEWS.PAGE_RESET:
      new_state.page = 0;
      new_state.articles = [];
      return new_state;
    case ACCOUNTS_NEWS.RESET:
      new_state.loading = false;
      new_state.articles = [];
      new_state.page = 0;
      return new_state;
    // the following reset is only for data if any in case of news
    case ACCOUNTS_NEWS.RESET_DATA:
      new_state.articles = [];
      new_state.page = 0;
      return new_state;

    case ACCOUNTS_NEWS.ADD_CURATE:
      new_state.articles = updateArticleCurationState(new_state.articles, action.curateArticleId, true);
      return new_state;
    case ACCOUNTS_NEWS.REMOVE_CURATE:
      new_state.articles = updateArticleCurationState(new_state.articles, action.curateArticleId, false);
      return new_state;
    case ACCOUNTS_NEWS.ADD_FAVOURITE:
      new_state.articles = state.articles.filter((item) => {
        if (item.id === action.articleId) {
          item.is_favourite = true;
        }
        return item;
      });
      return new_state;
    case ACCOUNTS_NEWS.REMOVE_FAVOURITE:
      new_state.articles = state.articles.filter((item) => {
        if (item.id === action.articleId) {
          item.is_favourite = false;
        }
        return item;
      });
      return new_state;

    case ACCOUNTS_NEWS.REMOVE_ALL_CURATE:
      new_state.articles = state.articles.map((item) => {
        if (item.is_curated) {
          item.is_curated = false;
        }
        return item;
      });
      return new_state;

    default:
      return state;
  }
};
